module.exports = __webpack_public_path__ + "static/img/BRISBANE-LIONS.2fec504.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BRISBANE-LIONS.svg
// module id = GGVM
// module chunks = 0